module.exports = __webpack_public_path__ + "static/media/pic_ka_qy.9d24c639.png";